import React from 'react'
import Box from '@mui/material/Box';
import CustomStepper from './CustomStepper'
import CustomLink from '../../../../common/CustomLink';
import { useCommonStyles } from '../../../../common/common';

const Checkout = () => {
    const commonClasses = useCommonStyles()
    return <Box className={commonClasses.mainContainer}>
        <CustomStepper 
            shopMore= {
                <CustomLink 
                    label="Shop More" 
                    url="/products" 
                />
            } 
        />
    </Box>
}

export default Checkout;
